import { render } from "./WaterQuality.vue?vue&type=template&id=c193a548&scoped=true"
import script from "./WaterQuality.vue?vue&type=script&lang=js"
export * from "./WaterQuality.vue?vue&type=script&lang=js"

import "./WaterQuality.vue?vue&type=style&index=0&id=c193a548&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c193a548"]])

export default __exports__